import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

export const CONE_5_PATTERN: SkillCastPattern = () => {
  return {
    [Direction.N]: [
      [0, -1, true],
      [0, -2],
      [-1, -2],
      [1, -2, true],
      [0, -3],
      [-1, -3],
      [1, -3, true],
      [0, -4],
      [-1, -4],
      [1, -4],
      [-2, -4],
      [2, -4, true],
      [0, -5],
      [-1, -5],
      [1, -5],
      [-2, -5],
      [2, -5],
    ],

    [Direction.NE]: [
      [1, -1, true],
      [1, -2],
      [2, -1],
      [2, -2, true],
      [2, -3],
      [3, -2],
      [3, -3, true],
      [2, -4],
      [4, -2],
      [3, -4],
      [4, -3],
      [4, -4, true],
      [3, -5],
      [5, -3],
      [4, -5],
      [5, -4],
      [5, -5],
    ],

    [Direction.E]: [
      [1, 0, true],
      [2, 0],
      [2, -1],
      [2, 1, true],
      [3, 0],
      [3, -1],
      [3, 1, true],
      [4, 0],
      [4, -1],
      [4, 1],
      [4, -2],
      [4, 2, true],
      [5, 0],
      [5, -1],
      [5, 1],
      [5, -2],
      [5, 2],
    ],

    [Direction.SE]: [
      [1, 1],
      [1, 2],
      [2, 1],
      [2, 2],
      [2, 3],
      [3, 2],
      [3, 3],
      [2, 4],
      [4, 2],
      [3, 4],
      [4, 3],
      [4, 4],
      [3, 5],
      [5, 3],
      [4, 5],
      [5, 4],
      [5, 5],
    ],

    [Direction.S]: [
      [0, 1, true],
      [0, 2],
      [-1, 2],
      [1, 2, true],
      [0, 3],
      [-1, 3],
      [1, 3, true],
      [0, 4],
      [-1, 4],
      [1, 4],
      [-2, 4],
      [2, 4, true],
      [0, 5],
      [-1, 5],
      [1, 5],
      [-2, 5],
      [2, 5],
    ],

    [Direction.SW]: [
      [-1, 1, true],
      [-2, 1],
      [-1, 2],
      [-2, 2, true],
      [-3, 2],
      [-2, 3],
      [-3, 3, true],
      [-4, 2],
      [-2, 4],
      [-4, 3],
      [-3, 4],
      [-4, 4, true],
      [-5, 3],
      [-3, 5],
      [-5, 4],
      [-4, 5],
      [-5, 5],
    ],

    [Direction.W]: [
      [-1, 0, true],
      [-2, 0],
      [-2, -1],
      [-2, 1, true],
      [-3, 0],
      [-3, -1],
      [-3, 1, true],
      [-4, 0],
      [-4, -1],
      [-4, 1],
      [-4, -2],
      [-4, 2, true],
      [-5, 0],
      [-5, -1],
      [-5, 1],
      [-5, -2],
      [-5, 2],
    ],

    [Direction.NW]: [
      [-1, -1, true],
      [-2, -1],
      [-1, -2],
      [-2, -2, true],
      [-3, -2],
      [-2, -3],
      [-3, -3, true],
      [-4, -2],
      [-2, -4],
      [-4, -3],
      [-3, -4],
      [-4, -4, true],
      [-5, -3],
      [-3, -5],
      [-5, -4],
      [-4, -5],
      [-5, -5],
    ],
  };
};
